import Api from './api';

const SecretariaService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/secretaria/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/secretaria/buscar?${params}`)
        return response
    }
}

export default SecretariaService;